import {DTOConversation, DTOConversationMessage} from './../../../../api/WickedApiClient';
import {MainService} from 'src/app/Services/service.service';
import {ConversationService} from './../../../../Services/conversationService';
import {Component, OnInit, Input, ViewChild, ElementRef, OnChanges, ViewChildren, QueryList, AfterViewInit} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {environment} from 'src/environments/environment';



@Component({
  selector: 'vng-chat-group-messages',
  templateUrl: './group-messages.component.html',
  styleUrls: ['./group-messages.component.scss'],
})
export class GroupMessagesComponent implements OnInit, OnChanges, AfterViewInit {

  conversations: DTOConversation[] = [];
  images: {} = {};
  @Input() public currentConversation: DTOConversation;
  @Input() public changesHelper: boolean = false;

  private _activeGroup: DTOConversation;
  public creationDate: Date;

  @ViewChild('bottom_anchor', {static: false}) private myScrollContainer: ElementRef;
  @ViewChildren('msgRef') msgRef: QueryList<any>;

  constructor(private mainService: MainService, private conversationService: ConversationService) { }

  ngAfterViewInit() {
    this.scrollToBottom();
    this.msgRef.changes.subscribe(() => {
      this.scrollToBottom()
    });
  }

  public messages: DTOConversationMessage[];

  ngOnInit() {
    this.messages = this.currentConversation!!.messages;
    this.scrollToBottom();
  }

  ngOnChanges() {
    this.messages = this.currentConversation!!.messages;
  }

  scrollToBottom(): void {
    const lastMsgRef = document.querySelectorAll(".vng-chat-message:last-child")[0];
    if(lastMsgRef) lastMsgRef.scrollIntoView();
  }

  prepareImages(message: DTOConversationMessage): {small: string, medium: string, big: string}[] {
    var images = message.images.map(img => {
      return {
        small: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        medium: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        big: `${environment.apiBaseUrl}/FileGet/${img.fileName}`
      }
    });

    return images;
  }

}

